import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { createSectionByIdSelector } from '../../../../redux/pages/selectors';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useShareClassHedgeSummaryPageQuery } from '../../../../api/rs-hg/risk/hooks/queries';
import type { ShareClassHedgeSummaryPageModel } from '../../../../api/rs-hg/risk/shareClassHedgeSummary.types';
import ShareClassHedgeSummaryTable from './ShareClassHedgeSummaryTable.component';

const ShareClassHedgeSummary: FC<GeneralOverviewPageRenderedComponentProps> = ({
  positionDate,
  section,
}) => {
  const sectionDetails = useSelector(createSectionByIdSelector(section));
  const fundTypes = sectionDetails?.fundTypes;

  const hedgeSummaryQuery = useShareClassHedgeSummaryPageQuery({
    positionDate: positionDate ?? '',
    fundTypes,
  });

  return (
    <QueryBoundary<ShareClassHedgeSummaryPageModel>
      isLoading={hedgeSummaryQuery.isLoading}
      isFetching={hedgeSummaryQuery.isFetching}
      isError={hedgeSummaryQuery.isError}
      error={hedgeSummaryQuery.error}
      data={hedgeSummaryQuery.data?.data?.length ? hedgeSummaryQuery.data : null}
      loadingMessages={['Loading Share Class Hedge Summary...']}
      errorMessage="Unable to load share class hedge summary data."
      noDataMessage="No share class hedge summary data available."
    >
      {(pageModel) => (
        <ShareClassHedgeSummaryTable
          rows={pageModel.data}
          positionDate={positionDate}
        />
      )}
    </QueryBoundary>
  );
};

export default ShareClassHedgeSummary;
